/* eslint-disable react/display-name */
import React from 'react'

export default ({ children, transparentBg }) => (
  <div className={!transparentBg && 'push'}>{children}</div>
)
